import type { FC, ReactNode } from 'react';
import React from 'react';

import { useGetCurrentUserQuery } from '../entities/session/api/sessionApi';
import { getToken } from '../shared/lib/token';

export const SessionGate: FC<{ children: ReactNode }> = ({ children }) => {
    const hasToken = Boolean(getToken());

    const { isSuccess, isError } = useGetCurrentUserQuery(undefined, { skip: !hasToken });

    const settled = !hasToken || isSuccess || isError;

    if (!settled) {
        return null;
    }

    return <>{children}</>;
};